<form [formGroup]="experienceForm" (ngSubmit)="saveExperience(inProgress)">
    <div class="modal-header">
      <h5 class="modal-title d-flex align-items-center">
        <i class="ri-file-text-line me-1 font-20 text-primary"></i>{{ experienceForm.value.id ? 'Update' : 'Add' }} Experience
      </h5>
      <button
        type="button"
        class="btn-close text-end"
        data-bs-dismiss="modal"
        aria-label="Close"
        (click)="activeModal.close('Close')"
      ></button>
    </div>
    <div class="modal-body">
      <div class="row g-3">
        <div class="col-md-5">
          <label for="title" class="form-label">Title <b class="text-secondary">*</b></label>
          <div class="input-group">
            <span class="input-group-text bg-transparent border-end-0"><i class="bx bx-briefcase"></i></span>
            <input
              type="text"
              class="form-control ps-1"
              id="title"
              placeholder="Enter title"
              formControlName="title"
              [ngClass]="{'is-invalid': submitted && f.title.errors}"
              autocomplete="off"
              ngbAutofocus
            />
            <div class="invalid-feedback" *ngIf="submitted && f.title.errors">
              <span *ngIf="f.title.errors.required">Please enter a valid title.</span>
              <span *ngIf="f.title.errors.pattern">Title can only contain letters and spaces.</span>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <label for="company" class="form-label">Company <b class="text-secondary">*</b></label>
          <div class="input-group">
            <span class="input-group-text bg-transparent border-end-0"><i class="bx bx-building"></i></span>
            <input
              type="text"
              class="form-control ps-1"
              id="company"
              placeholder="Enter company"
              formControlName="company"
              [ngClass]="{'is-invalid': submitted && f.company.errors}"
              autocomplete="off"
            />
            <div class="invalid-feedback" *ngIf="submitted && f.company.errors">
              <span *ngIf="f.company.errors.required">Please enter a valid company.</span>
              <span *ngIf="f.company.errors.pattern">Company name can only contain letters and spaces.</span>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <label for="startDate" class="form-label">Start Date <b class="text-secondary">*</b></label>
          <div class="input-group">
            <span class="input-group-text bg-transparent border-end-0"><i class="bx bx-calendar"></i></span>
            <input
              type="date"
              class="form-control ps-1"
              id="startDate"
              formControlName="startDate"
              [ngClass]="{'is-invalid': submitted && f.startDate.errors}"
            />
            <div class="invalid-feedback" *ngIf="submitted && f.startDate.errors">
              <span *ngIf="f.startDate.errors.required">Please select a start date.</span>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <label for="endDate" class="form-label">End Date <b class="text-secondary">*</b></label>
          <div class="input-group">
            <span class="input-group-text bg-transparent border-end-0"><i class="bx bx-calendar"></i></span>
            <input
              type="date"
              class="form-control ps-1"
              id="endDate"
              formControlName="endDate"
              [ngClass]="{'is-invalid': submitted && f.endDate.errors}"
            />
            <div class="invalid-feedback" *ngIf="submitted && f.endDate.errors">
              <span *ngIf="f.endDate.errors">Please select a valid end date.</span>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <label for="location" class="form-label">Location <b class="text-secondary">*</b></label>
          <div class="input-group">
            <span class="input-group-text bg-transparent border-end-0"><i class="bx bx-map"></i></span>
            <input
              type="text"
              class="form-control ps-1"
              id="location"
              placeholder="Enter location"
              formControlName="location"
              [ngClass]="{'is-invalid': submitted && f.location.errors}"
              autocomplete="off"
            />
            <div class="invalid-feedback" *ngIf="submitted && f.location.errors">
              <span *ngIf="f.location.errors.required">Please enter a valid location.</span>
              <span *ngIf="f.location.errors.pattern">Location can only contain letters, spaces</span>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <label for="locationType" class="form-label">Location Type <b class="text-secondary">*</b></label>
          <div class="input-group">
            <span class="input-group-text bg-transparent border-end-0"><i class="bx bx-grid-alt"></i></span>
            <ng-select
              class="form-control rcx-ng-select"
              formControlName="locationType"
              placeholder="Select location type"
              [ngClass]="{'is-invalid': submitted && f.locationType.errors}"
              [clearable]="false"
            >
              <ng-option *ngFor="let type of locationTypes" [value]="type">{{ type }}</ng-option>
            </ng-select>
            <div class="invalid-feedback" *ngIf="submitted && f.locationType.errors">
              <span *ngIf="f.locationType.errors.required">Please select a location type.</span>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <label for="employmentType" class="form-label">Employment Type <b class="text-secondary">*</b></label>
          <div class="input-group">
            <span class="input-group-text bg-transparent border-end-0"><i class="bx bx-grid-alt"></i></span>
            <ng-select
              class="form-control rcx-ng-select"
              formControlName="employmentType"
              placeholder="Select employment type"
              [ngClass]="{'is-invalid': submitted && f.employmentType.errors}"
              [clearable]="false"
            >
              <ng-option *ngFor="let type of employmentTypes" [value]="type">{{ type }}</ng-option>
            </ng-select>
            <div class="invalid-feedback" *ngIf="submitted && f.employmentType.errors">
              <span *ngIf="f.employmentType.errors.required">Please select an employment type.</span>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <label for="documentUrl" class="form-label">Document File</label>
          <div class="input-group">
            <input type="file" class="custom-file-input form-control" id="documentUrl" 
                   accept=".jpg,.jpeg,.png,.pdf" 
                   (change)="onFileSelected($event)">
          </div>
        </div>
        <div class="col-md-6">
          <label for="description" class="form-label">Description </label>
          <div class="input-group">
            <span class="input-group-text bg-transparent border-end-0"><i class="bx bx-detail"></i></span>
            <textarea
              class="form-control ps-1"
              id="description"
              formControlName="description"
              placeholder="Enter description"
              cols="1" rows="1"
              [ngClass]="{'is-invalid': submitted && f.description.errors}"
            ></textarea>
            <div class="invalid-feedback" *ngIf="submitted && f.description.errors">
              <span *ngIf="f.description.errors.required">Please enter a description.</span>
            </div>
          </div>
        </div>
        <div class="col-md-auto">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="disabled" formControlName="disabled" />
            <label class="form-check-label" for="disabled">Disabled</label>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="activeModal.close('Close')">
        <i class="bx bx-x"></i>Close
      </button>
      <button
        type="submit"
        class="btn btn-secondary"
        #inProgress
        [ngClass]="{'no-event': inProgress?.value == 'true'}"
      >
        <ng-container *ngIf="inProgress?.value == 'true'">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{ experienceForm.value.id ? 'Updating...' : 'Saving...' }}
        </ng-container>
        <ng-container *ngIf="inProgress?.value != 'true'">
          <i class="bx bx-save"></i>{{ experienceForm.value.id ? 'Save Changes' : 'Save' }}
        </ng-container>
      </button>
    </div>
  </form>